import React from 'react';
import PropTypes from 'prop-types';
import { humaniseString } from '../../../utils/stringConversion';
import MessageBox from './MessageBox';

const ContentRestrictedMessage = ({ access, organisation, ...rest }) => {
  let readableMinAccessLevel;
  let message;
  let signupCtaText;

  if (access.minimum_access_level === `basic`) {
    signupCtaText = `Sign up for free`;
  } else {
    signupCtaText = `Sign up`;
  }
  // If the user cannot access this content
  if (access.canIAccess === false) {
    readableMinAccessLevel = humaniseString(access.minimum_access_level);

    // If the user is not logged in
    if (access.loggedIn === false) {
      const currentPath = location.pathname;
      // Not logged in and no way to sign up
      if (organisation && organisation.signupRedirect) {
        message = (
          <div>
            <p className="h3">You must <a href={`/login?returnPath=${currentPath}`}>Login</a> to access this
                      content.</p>
            <p className="h3">If you do not have an account, contact your club administrator to discus setting one
                      up for you.</p>
          </div>
          );
        // Not logged in and stripe is enabled
      } else if (organisation && organisation.stripeEnabled) {
        message = (
          <div>
            <p className="h3">This content is restricted to <span className="fw-medium">{readableMinAccessLevel}</span> members.</p>
            <p className="h3">Already a <span className="fw-medium">{readableMinAccessLevel}</span> member? <a href={`/login?returnPath=${currentPath}`}>Login</a> to access this content.</p>
            <p className="h3">Not a member? Sign up to a <span className="fw-medium">{readableMinAccessLevel}</span> plan to gain access to unrivaled coaching content.</p>
            <a href={`/signup?plan_type=${access.minimum_access_level}`} className="btn">{signupCtaText}</a>
          </div>
      );
        // Not logged in and stripe is NOT enabled so don't mention plans
      } else {
        message = (
          <div>
            <p className="h3">This content is restricted to <span className="fw-medium">{readableMinAccessLevel}</span> members.</p>
            <p className="h3">Already a <span className="fw-medium">{readableMinAccessLevel}</span> member? <a href={`/login?returnPath=${currentPath}`}>Login</a> to access this content.</p>
          </div>
      );
      }
      // Logged in and stripe is enabled
    } else if (organisation && organisation.stripeEnabled) {
      message = (
        <div>
          <p className="h3">Upgrade to a <span className="fw-medium">{readableMinAccessLevel}</span> plan to continue reading this exclusive content.</p>
          <a href="/account/plan" className="btn">View upgrade options</a>
        </div>
      );
    } else {
        // Logged in and stripe is not enabled
      message = (
        <div>
          <p className="h3">This content is restricted to <span className="fw-medium">{readableMinAccessLevel}</span> members.</p>
          <p className="h3">Contact your club administrator to access this content.</p>
        </div>
      );
    }
  // If the user isn't logged in but viewing an unrestricted article we want to show a sign up CTA
  } else if (access.loggedIn === false) {
      // Signup is not available
    if (organisation && organisation.signupRedirect) {
      const currentPath = location.pathname;
      message = (
        <div>
          <div>
            <p className="h3">You must <a href={`/login?returnPath=${currentPath}`}>Login</a> to access this content.</p>
            <p className="h3">If you do not have an account, contact your club administrator to set one up for you.</p>
          </div>
        </div>
    );
    } else {
      message = (
        <div>
          <p className="h3">Sign up to The Coaching Manual for more great content like this.</p>
          <a href="/signup" className="btn">{signupCtaText}</a>
        </div>
    );
    }
  }

  return (
    <div className="content-restricted-message">
      <MessageBox {...rest}>
        <p className="message-box__title h1 fw-bold">Want to read more?</p>
        {message}
      </MessageBox>
    </div>
  );
};

ContentRestrictedMessage.propTypes = {
  access: PropTypes.object,
  organisation: PropTypes.object,
};

export default ContentRestrictedMessage;



// WEBPACK FOOTER //
// ./library/app/components/Global/Messages/ContentRestrictedMessage.js